import type { Component } from 'vue'
import type { RouteMeta } from 'vue-router'

import LayoutAi from './LayoutAi.vue'
import LayoutFull from './LayoutFull.vue'
import LayoutOnboarding from './LayoutOnboarding.vue'
import LayoutVertical from './LayoutVertical.vue'

/**
 * The frame of a route (`meta.layout`, src/app/router/meta.ts): `full` — the page alone; `ai` — the top bar over the
 * page, no sidebar (AI mode, docs/ai-mode/wp/AI-1.md); `onboarding` — the slim bar of the setup wizard (App.vue decides
 * it from `meta.onboarding` and the workspace); anything else — the vertical layout.
 */
export function layoutOf(meta: Pick<RouteMeta, 'layout'>, { onboarding = false } = {}): Component {
  if (meta.layout === 'full') return LayoutFull
  if (meta.layout === 'ai') return LayoutAi
  return onboarding ? LayoutOnboarding : LayoutVertical
}
